export const WINDOW_POLL_INTERVAL = 250
export const WINDOW_FEATURES =
  'menubar=yes,location=no,toolbar=yes,scrollbars=yes,resizable=yes,directories=no,status=yes'
